<form>
    <mayer-warehouse-selector #warehouseIDField name="warehouseID" [(ngModel)]="warehouseID">
    </mayer-warehouse-selector>

    <mat-form-field [style.width.px]=120 [style.marginRight.px]=10 appearance="fill">
        <mat-label>Bin/Location</mat-label>
        <input #locationIDField name="locationID" id="locationID" matInput [(ngModel)]="locationID" autofocus />
        <button type="button" mat-button *ngIf="locationID" matSuffix mat-icon-button (click)="locationID=''">
            <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>
    <button (click)="selectLocation()" color="primary" mat-mini-fab>
        <mat-icon>search</mat-icon>
    </button>
</form>

<mat-card style="text-align:center;" *ngIf="dataFetched && items.length == 0">
    No matching records found<br />
    Invalid Location ID?
</mat-card>

<mat-accordion>
    <mat-expansion-panel hideToggle *ngFor="let item of items">
        <mat-expansion-panel-header>
            <mat-panel-title style="white-space:nowrap;">
                <item-thumbnail [item]="item"></item-thumbnail>
                {{item.InventoryID}}
            </mat-panel-title>
            <mat-panel-description>
                {{item.Description | titleCase}}
            </mat-panel-description>
        </mat-expansion-panel-header>

        <table mat-table *ngIf="item.LotsTable" [dataSource]="item.LotsTable">
            <ng-container matColumnDef="LotSerialNbr">
                <th mat-header-cell *matHeaderCellDef>Lot/Ser #</th>
                <td mat-cell *matCellDef="let value">{{value.LotSerialHash}}<br />{{value.LotSerialNbr}}</td>
            </ng-container>

            <ng-container matColumnDef="QtyOnHand">
                <th mat-header-cell *matHeaderCellDef style="text-align: right;">On Hand</th>
                <td mat-cell *matCellDef="let value" class="numeric" [innerHtml]="value.QtyOnHand | quantityFraction">
                </td>
            </ng-container>

            <ng-container matColumnDef="QtyAvailable">
                <th mat-header-cell *matHeaderCellDef style="text-align: right;">Qty Avail</th>
                <td mat-cell *matCellDef="let value" class="numeric"
                    [innerHtml]="value.QtyAvailable | quantityFraction">
                </td>
            </ng-container>

            <ng-container matColumnDef="menu">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let lot" class="numeric">
                    <buton mat-button [matMenuTriggerFor]="menu">
                        <mat-icon>more_vert</mat-icon>
                    </buton>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="printStockTag(item, lot)">
                            <mat-icon>sell</mat-icon>Stock Tag
                        </button>
                        <button mat-menu-item (click)="inventoryAdjustment(item, lot)">
                            <mat-icon>expand</mat-icon>Adjust Qty
                        </button>
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef=" lotQtyColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: lotQtyColumns;"></tr>
        </table>
    </mat-expansion-panel>
</mat-accordion>